import * as React from 'react';
import { UIText3, IconReload16 } from '@cian/ui-kit';
import { Attention16 } from '@cian/ui-kit/prev';
import * as styles from './PreviewFallback.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PreviewFallback = function PreviewFallback(_ref) {
  var onRetry = _ref.onRetry;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['error'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['icon'],
        children: /*#__PURE__*/_jsx(Attention16, {
          color: "gray_icons_100"
        })
      }), /*#__PURE__*/_jsx(UIText3, {
        color: "gray60_100",
        as: "span",
        children: "\u041E\u0448\u0438\u0431\u043A\u0430"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['retry'],
      children: /*#__PURE__*/_jsxs("button", {
        className: styles['button'],
        type: "button",
        onClick: onRetry,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['icon'],
          children: /*#__PURE__*/_jsx(IconReload16, {
            color: "primary_100"
          })
        }), /*#__PURE__*/_jsx(UIText3, {
          color: "primary_100",
          as: "span",
          children: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C"
        })]
      })
    })]
  });
};